import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import { IconFile, IconTrash } from "@tabler/icons-react";
import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import { isValidFileType } from "../../../helpers/fileHelper";
import { Alert } from "@material-ui/lab";

const schema = yup.object().shape({
  type: yup.string().required("Tipo es requerido"),
  document_file: yup.array<File>().min(1, "Documento es requerido").required(),
});

interface props {
  id_bl: number;
  isLoading: boolean;
  onCancel: () => void;
  submit: (type: string, file: File) => void;
}

export default function FormUploadDocument({
  id_bl,
  isLoading,
  onCancel,
  submit,
}: props) {
  const [errorFileType, setErrorFileType] = useState(false);

  const { values, setFieldValue, errors, touched, handleSubmit } = useFormik({
    initialValues: {
      type: "",
      document_file: Array<File>(),
    },
    validationSchema: schema,
    onSubmit(values) {
      const isValidFile = isValidFileType(
        "application/pdf",
        values.document_file[0]
      );

      if (isValidFile === false) {
        setErrorFileType(true);
        return;
      }

      submit(values.type, values.document_file[0]);
    },
  });

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <FormControl error={Boolean(errors.type && touched.type)}>
            <FormLabel>Tipo de Documento</FormLabel>
            <RadioGroup onChange={(_, val) => setFieldValue("type", val)}>
              <FormControlLabel
                value={"CAR"}
                control={<Radio color="primary" />}
                label="CARTA"
              />
              <FormControlLabel
                value={"BL"}
                control={<Radio color="primary" />}
                label="BL"
              />
            </RadioGroup>
            <FormHelperText>{errors.type}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12}>
          <input
            id="icon-button-file"
            hidden
            accept="application/pdf"
            type="file"
            onChange={(e) => {
              const val =
                e.target.files instanceof FileList
                  ? e.target.files[0]
                  : undefined;
              if (val === undefined) return;
              setFieldValue("document_file", [val]);
            }}
          />
          <FormControl
            error={Boolean(errors.document_file && touched.document_file)}
            fullWidth
          >
            <FormLabel>Documento</FormLabel>
            {values.document_file?.length > 0 ? (
              <TextField
                value={values.document_file[0].name}
                variant="outlined"
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <IconButton
                      onClick={() => {
                        setFieldValue("document_file", []);
                        setErrorFileType(false);
                      }}
                    >
                      <IconTrash />
                    </IconButton>
                  ),
                }}
              />
            ) : (
              <label htmlFor="icon-button-file">
                <Paper
                  variant="outlined"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                    borderColor: Boolean(
                      errors.document_file && touched.document_file
                    )
                      ? "red"
                      : "",
                  }}
                >
                  <IconFile />
                  <Typography variant="subtitle1">Cargar Documento</Typography>
                </Paper>
              </label>
            )}
            <FormHelperText>
              {typeof errors.document_file == "string"
                ? errors.document_file
                : ""}
            </FormHelperText>
          </FormControl>
        </Grid>
        {errorFileType === true ? (
          <Grid xs={12}>
            <Alert severity="error">
              El tipo documento no es el correcto. Seleccione solo PDF
            </Alert>
          </Grid>
        ) : null}

        <Grid item xs={6}>
          <Button fullWidth variant="text" size="large" onClick={onCancel}>
            Cancelar
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            size="large"
            onClick={() => handleSubmit()}
            disabled={isLoading}
            endIcon={isLoading === true ? <CircularProgress size={20} /> : null}
          >
            Subir Documento
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
